// src/features/projects/components/ProjectHeroSection.tsx

import React from 'react';
import styles from './ProjectHeroSection.module.scss';
import SplitText from './SplitText';
import { Hero, Meta } from '../types/project';

// Import local thumbnail images
import lasemaineImage from '../../../shared/assets/images/project-thumbnails/lasemaine.png';
import alvoImage from '../../../shared/assets/images/project-thumbnails/alvo.png';
import amurabiImage from '../../../shared/assets/images/project-thumbnails/amurabi.png';
import tunisrhImage from '../../../shared/assets/images/project-thumbnails/tunisrh.png';
import bookmyroomImage from '../../../shared/assets/images/project-thumbnails/bookmyroom.jpg';
import quoteFlowImage from '../../../shared/assets/images/project-thumbnails/Flitter-quote.png';

interface ProjectHeroSectionProps {
  hero: Hero;
  meta: Meta;
}

const ProjectHeroSection: React.FC<ProjectHeroSectionProps> = ({ hero, meta }) => {
  // Image mapping for local thumbnails
  const imageMap: { [key: string]: string } = {
    'la-semaine': lasemaineImage,
    'alvo-marketplace': alvoImage,
    'amurabi-poc': amurabiImage,
    'tunisrh': tunisrhImage,
    'bookmyroom': bookmyroomImage,
    'quote-flow': quoteFlowImage,
  };

  // Extract project ID from hero image URL or use a fallback
  const getProjectImage = (): string => {
    // Try to match project ID from the current URL or project data
    const currentPath = window.location.pathname;
    const projectId = currentPath.split('/').pop();
    return projectId && imageMap[projectId] ? imageMap[projectId] : hero.image;
  };

  return (
    <section className={styles.heroSection}>
      <div className={styles.heroContent}>
        {/* Main Content Grid */}
        <div className={styles.contentGrid}>
          {/* Left: Title, Description and Meta */}
          <div className={styles.textContent}>
            <div className={styles.titleWrapper}>
              <SplitText
                text={hero.title}
                className={styles.animatedTitle}
                delay={80}
              />
              <p className={styles.description}>{hero.subtitle}</p>
            </div>
            
            {/* Project Meta Info */}
            <div className={styles.metaInfo}>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Timeline</span>
                <span className={styles.metaValue}>{meta.timeframe}</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>Client</span>
                <span className={styles.metaValue}>{meta.madeAt}</span>
              </div>
            </div>
          </div>

          {/* Right: Project Image */}
          <div className={styles.imageContent}>
            <div className={styles.imageWrapper}>
              <img 
                src={getProjectImage()} 
                alt={hero.title}
                className={styles.heroImage}
              />
              <div className={styles.imageOverlay}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectHeroSection;